import classes from "./report-recalls.module.scss";

export const ReportRecalls = () => {
    return (
        <div className={classes.recall}>
            <div className={classes.recall__desc}>
                Иногда производители отзывают свои автомобили из-за некачественных деталей или
                сборки. Замена всегда происходит бесплатно и независимо от гарантии. В Росстандарте
                собрана полная база данных всех отзывных кампаний с 2014 года.
            </div>
            <span className={classes.recall__status}>Отзывных кампаний нет</span>
            <div className={classes.recall__sub}>На территории РФ по данным Росстандарта</div>
        </div>
    );
};